import * as React from "react"
import {Navigate} from "react-router-dom";

import {PRODUCT_PAGE_ROUTES} from "@constants"
import AppLayout from "Layout"
import ProductPageDetailsPage from "./Details"
import ProductPagesKpiPage from "./Kpi";
import ProductPageImageDetailsPage from "./ImageDetails";


export const ProductPageRoutes = {
    path: PRODUCT_PAGE_ROUTES.PATH,
    title: PRODUCT_PAGE_ROUTES.TITLE,
    accessKey: PRODUCT_PAGE_ROUTES.ACCESS_KEY,
    icon: 'camera-web',
    description: "Evaluate and Optimize the Performance of Your Product Listings",
    element: <AppLayout />,
    children: [{
        element: <Navigate to={PRODUCT_PAGE_ROUTES.KPIS_PATH} replace />,  index: true
    }, {
        title: 'Product Pages KPIs',
        path: PRODUCT_PAGE_ROUTES.KPIS_PATH,
        dashboardKey: PRODUCT_PAGE_ROUTES.KPIS_ID,
        element: <ProductPagesKpiPage />
    }, {
        path: 'divider'
    }, {
        title: 'Product Pages Details',
        path: PRODUCT_PAGE_ROUTES.DETAILS_PATH,
        dashboardKey: PRODUCT_PAGE_ROUTES.DETAILS_ID,
        element: <ProductPageDetailsPage />
    }, {
        title: 'Product Pages Image Details',
        path: PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_PATH,
        dashboardKey: PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_ID,
        element: <ProductPageImageDetailsPage />
    }]
}